export const isAllowedDomainValid = (value: string) => !value.includes('/');
